import { render } from "./EditProspection.vue?vue&type=template&id=55df7e98&scoped=true"
import script from "./EditProspection.vue?vue&type=script&lang=js"
export * from "./EditProspection.vue?vue&type=script&lang=js"

import "./EditProspection.vue?vue&type=style&index=0&id=55df7e98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55df7e98"]])

export default __exports__